import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

// 사용자 회원으로 push 전송
const USER_APP_ID = 'fa7f3c3e-eec7-4cc4-a6d2-0cb9ef125737';
const USER_ANDROID_CHANNEL_ID = 'd4a2a3a5-feeb-4f36-9b9d-501024c20c52';

@Injectable({
  providedIn: 'root',
})
export class PushService {
  constructor(
    private httpClient: HttpClient,
  ) { }

  sendPush(pushIds: Array<string>, message: string, data?: any, title = '우리푸드') {
    console.log(pushIds);

    return new Promise<any>((resolve, reject) => {
      const options = {
        headers: {
          //onesignal에서 제공하는 기본 셋팅
          Authorization: 'Bearer NmIyMzUyNzktYmIxMy00ZjczLWFiMDQtMDA2YmQ2MThmYjJj',
          'Content-Type': 'application/json; charset=utf-8',
        },
      };
      const body = {
        //push 정보
        app_id: USER_APP_ID,
        name: title,
        headings: { en: title },
        contents: { en: message },
        data,
        include_subscription_ids: pushIds,
        included_segments: ['Subscribed Users'], // 'Active Users', 'Inactive Users'],
        android_channel_id: USER_ANDROID_CHANNEL_ID,
      };
      if (pushIds) {
        //로그인을 했을 경우에만
        this.httpClient.post('https://onesignal.com/api/v1/notifications', body, options).subscribe(data => {
          console.log('data :', data);
          resolve(data);
        });
      }
    });
  }


}
